import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-order-pricing',
  templateUrl: './order-pricing.component.html',
  styleUrls: ['./order-pricing.component.css']
})
export class OrderPricingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
